import format from 'date-fns/format';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { currencyInputFormat } from '~/utils';

export const formatAmount = (loanOptions, index, path, decimals) => {
  let amount = get(loanOptions, `[${index}].${path}`);
  if (amount === undefined || amount === null) {
    return '';
  }
  amount = (decimals === undefined)? amount.toFixed(2): amount.toFixed(decimals);
  return (amount !== undefined && amount !== null)? currencyInputFormat(amount.toString(), { thousandSeparator: ',', symbol: '$' }) : '';
};

export const formatAmountByValue = (amount, decimals) => {
  if (amount === undefined || amount === null) {
    return '';
  }
  amount = (decimals === undefined)? amount.toFixed(2): amount.toFixed(decimals);
  return currencyInputFormat(amount.toString(), { thousandSeparator: ',', symbol: '$' });
};

export const formatDateObj = (dateObj) => {
  return (dateObj === null || dateObj === undefined || !(dateObj instanceof Date))? '': format(dateObj, 'DD/MM/YYYY');
};

export const formatDateTimeObj = (dateObj) => {
  return (dateObj === null || dateObj === undefined || !(dateObj instanceof Date))? '': format(dateObj, 'DD/MM/YYYY HH:mm:ss');
};

export const formatTimeObj = (dateObj) => {
  return (dateObj === null || dateObj === undefined || !(dateObj instanceof Date))? '': format(dateObj, 'HH:mm:ss');
};

export const formatAccountWithMaskChar = (account, maskChar) => {
  let maskedString = '';
  let unmaskedString = '';

  if (isEmpty(account) || account.length < 4)
    return '';

  let len = account.length;
  for (let i=0; i<len-4; i++) {
    maskedString = maskedString + maskChar;
  }
  unmaskedString = account.substring(len-4, len);
  return `${maskedString}${unmaskedString}`;
};
